import { css } from "@emotion/react";
import { styleUtils } from "@minted/minted-components";
import React, { memo } from "react";

/**
 * Square media treatment — two photos in a row (legacy l2 /
 * WeddingHomeVerticalDoubleHeader image slot; 1:1 crop). Design theme does
 * not style these images; layout CSS only. The legacy SmallGraphic between
 * photos is intentionally omitted (theme ornament, not media structure).
 */
const styles = {
  image: css`
    aspect-ratio: 1 / 1;
    box-sizing: border-box;
    display: block;
    object-fit: cover;
    width: 100%;
  `,
  leftPhoto: css`
    flex: 0 0 46%;
    margin-right: 8%;
  `,
  rightPhoto: css`
    flex: 0 0 46%;
  `,
  row: css`
    align-items: center;
    display: flex;
    flex-direction: row;
    margin-bottom: ${styleUtils.rem(30)};
  `,
  // Same content gutter as LandscapeMedia / fancyclothes Wrapper.
  wrapper: css`
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    max-width: ${styleUtils.rem(1170)};
    padding-left: ${styleUtils.rem(15)};
    padding-right: ${styleUtils.rem(15)};
  `,
};

export type SquareMediaProps = {
  alt: string;
  leftPhotoURL: string;
  rightPhotoURL: string;
};

const SquareMedia = ({
  alt,
  leftPhotoURL,
  rightPhotoURL,
}: SquareMediaProps) => (
  <div css={styles.wrapper}>
    <div css={styles.row}>
      <div css={styles.leftPhoto}>
        <img
          alt={alt}
          css={styles.image}
          data-cy="leftImage"
          src={leftPhotoURL}
        />
      </div>
      <div css={styles.rightPhoto}>
        <img
          alt={alt}
          css={styles.image}
          data-cy="rightImage"
          src={rightPhotoURL}
        />
      </div>
    </div>
  </div>
);

const MemoizedSquareMedia = memo(SquareMedia);

export { MemoizedSquareMedia as SquareMedia };
